import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-localization-icon',
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.864 21.5">
      <g transform="translate(-2.25 -0.25)">
        <path
          d="M19.364,9.182C19.364,15.545,11.182,21,11.182,21S3,15.545,3,9.182a8.182,8.182,0,0,1,16.364,0Z"
          fill="none"
          stroke="#2acc16"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
        <circle
          cx="2.727"
          cy="2.727"
          r="2.727"
          transform="translate(8.455 6.455)"
          fill="none"
          stroke="#2acc16"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
      </g>
    </svg>
  `,
  styles: [
    `
      svg {
        display: block;
      }
    `,
  ],
})
export class LocalizationIconComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
